import { useState, useEffect, useCallback } from "react";
import { supabase } from "../../configs/supabase";
import { Order } from "../types/order";
import { CountCustomerProduct } from "../types/customerProduct";
import dayjs, { Dayjs } from 'dayjs';
import { Customer } from "../types/customer";
import { DataFetchError } from "../../utils/ErrorClass";
dayjs.locale('ja'); // 日本語ロケールを設定


export const useOrder = () => {
  const [order, setOrder] = useState<Order>();
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('order')
        .select('*')
        .order('受注番号', { ascending: false })
        .limit(1)
        .single();

      if (error) {
        throw new DataFetchError(error.message);
      }

      setOrder(data as Order);
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { order, error };
};


const fetchShipDetails = async (ship_id: number) => {
  try {
    const { data, error } = await supabase
      .from('customer')
      .select('*')
      .eq('id', ship_id)
      .single();

    if (error) {
      throw new DataFetchError(error.message);
    }

    return data as Customer;
  } catch (err) {
    console.error('Error fetching ship details:', err);
    throw err;
  }
};

export const addOrder = async (
  customer: Customer,
  deliver_date: Dayjs,
  ship_id: number,
  comment: string,
  products: CountCustomerProduct[],
  maxRetries = 3
) => {
  let attempt = 0;
  while (attempt < maxRetries) {
    try {
      const productData = products.map((product, index) => ({
        index: index + 1,
        product_id: product.product_id,
        product_name: product.product_name,
        count: product.count,
        product_unit: product.product_unit,
        product_tax_flag: product.product_tax_flag
      }));

      const { error } = await supabase.rpc('add_order_rpc', {
        customer_id: customer.id,
        customer_name: customer.name,
        deliver_date: deliver_date.format('YYYY-MM-DD'),
        ship_id: ship_id,
        ship_name: (await fetchShipDetails(ship_id)).name,
        ship_address: (await fetchShipDetails(ship_id)).address1,
        comment: comment,
        products: productData
      });

      if (error) throw error;

      // 成功した場合はループを抜ける
      return;

    } catch (error) {
      console.error("Error adding order:", error);

      // リトライカウントを増やす
      attempt += 1;

      if (attempt >= maxRetries) {
        throw new Error('Max retries reached. Order could not be added.');
      }
    }
  }
};